import React from 'react'
import { Link } from 'react-router-dom'
import { AMMINISTRAZIONE_TRASPARENTE_URL } from '../../constants'

const Footer = () => {
    return (
        <div id="footer" className='flex-shrink-0 bg-gray-bg w-full mt-auto'>
            {/* <footer className='absolute bottom-0 z-[-1] flex-shrink-0'> */}
            <div className="container mx-auto flex flex-col items-center justify-between px-4 lg:px-0 mb-0">
                <div className='flex items-center justify-center py-8'>
                    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-12">
                        <div className="flex items-start gap-x-4">
                            <div className="w-full md:w-[70%] lg:w-full">
                                <Link to={"/"} className="">
                                    <img src="/images/logo2.png" alt="" className="w-full" />
                                </Link>
                            </div>
                        </div>

                        <div className="lg:col-span-2 w-full flex flex-col space-x-0 md: lg:space-x-0 items-start text-blue-text">
                            <div className='flex flex-col items-start mb-4'>
                                <p className='mb-0 text-sm font-bold'>Villa Papa Giovanni XXIII s.r.l</p>
                                <p className='mb-0 text-sm font-normal'>Direzione e coordinamento I.R. Holding s.r.l.</p>
                                <p className='mb-0 text-sm font-normal'>Str. San Gillio 75 - 10044 Pianezza TO</p>
                                <p className='mb-0 text-sm font-normal'>Sede Legale: Piazza Gozzano 1 – 10132 Torino (TO)</p>
                                <p className='mb-1 text-sm font-normal'>P.IVA: 00491660015</p>
                                <p className='mb-0 text-sm font-normal'>Capitale Sociale: 28.405,00 i.v.</p>
                                <p className='mb-0 text-sm font-normal'>REA: TO-460899</p>
                                <p className='mb-0 text-sm font-normal'>PEC: <a href='mailto:papagiovanni23@legalmail.it'>papagiovanni23@legalmail.it</a></p>
                            </div>

                            <div className='flex flex-wrap'>
                                <p className='mb-0 text-sm font-normal'>struttura accreditata con il servizio sanitario nazionale - PAPA GIOVANNI XXIII SRL</p>
                                <div className='flex flex-col sm:flex-row sm:flex-wrap gap-x-4 font-bold'>
                                    <Link to={AMMINISTRAZIONE_TRASPARENTE_URL} className='mb-0 underline hover:cursor-pointer'>AMMINISTRAZIONE TRASPARENTE</Link>
                                    <p className='mb-0 hidden sm:block'>|</p>
                                    <Link to={"/privacy-policy"} className='mb-0 underline hover:cursor-pointer'>PRIVACY POLICY</Link>
                                    <p className='mb-0 hidden sm:block'>|</p>
                                    <Link to={"/cookie-policy"} className='mb-0 underline hover:cursor-pointer'>COOKIE POLICY</Link>
                                    <p className='mb-0 hidden sm:block'>|</p>
                                    <Link to={"/whistleblowing"} className='mb-0 underline hover:cursor-pointer'>WHISTLEBLOWING</Link>
                                    {/* <p className='mb-0'>|</p> */}
                                    {/* <Link to={"https://poliambulatorio.s3.us-west-2.amazonaws.com/Carta_Servizi_Villa+Iris_2024.pdf"} className='mb-0 underline hover:cursor-pointer'>CARTA DEI SERVIZI</Link> */}
                                    {/* <a href="/images/documents/2025carta-servizi-xxiii-(1).pdf" target="_blank" className="mb-0 underline hover:cursor-pointer">
                                        CARTA DEI SERVIZI
                                    </a> */}
                                    <p className='mb-0 hidden sm:block'>|</p>
                                    <a 
                                        href="/images/documents/POLITICA-DELLA-QUALITa-2025.pdf"
                                        download
                                        className="mb-0 underline hover:cursor-pointer"
                                        >
                                        POLITICA DELLA QUALITÀ
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
// privacy-policy
// cookie-policy
// whistleblowing